import { VStack } from '@sgme/ui';
import clsx from 'clsx';
import type { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  className?: string;
  onClose?: () => void;
  preventCloseButtonToHideContent?: boolean;
}>;

export const BlotterDrawerWrap = ({ className, onClose, children, preventCloseButtonToHideContent = false }: Props) => {
  return (
    <article className={clsx(className, 'h-100 position-relative bg-lvl1 justify-content-between border-start p-2')}>
      <button
        type="button"
        className="btn btn-default btn-sm bg-white position-absolute"
        style={{ top: 4, right: 4, zIndex: 1 }}
        onClick={() => onClose?.()}
        data-e2e="blotter-detailsPanel-closeButton"
      >
        <i className="icon icon-sm">close</i>
      </button>
      <VStack className={clsx('h-100', preventCloseButtonToHideContent && 'pt-4')}>{children}</VStack>
    </article>
  );
};
